export const adminEventReminders = (params: { eventId: number }) => `event:${params.eventId}`;
